import { render, staticRenderFns } from "./NikudOptionsDialog.vue?vue&type=template&id=0cd52d29&"
import script from "./NikudOptionsDialog.vue?vue&type=script&lang=js&"
export * from "./NikudOptionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./NikudOptionsDialog.vue?vue&type=style&index=0&id=0cd52d29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports